














































on_clickaway = require('vue-clickaway')
exports.default =
  components:
    carouselModalCustom: require '../modal_carousel_custom.vue'
  mixins: [ on_clickaway.mixin ]
  props:
    selected: 
      type: String
      default: ''

  data: ->
    active: {}
    dados: {}
    property_id_group: {}
    property_id: null
    datacopy: false
    dados_modal:{}
    selected_copy: {}
    config: false
    show_modal: false
    loading_users: true
    loading_table: false
    loading_carousel: true
    users: []
    id:  null
    custom_select: {}
    custom_select_value: null
    custom_select_id: null
    current_user: Session.current_user
    company_id: Session.current_company.id

  computed:
    loading: ->
      @loading_users || @loading_carousel

  watch:
    selected: ->
      params = { q: { kind_eq: 'dropdown' } }
      new CustomFieldsResource().index(@successId, null, params)
      @loadUsers()
      @loadCarousel()

  methods:
    dropOpen: (item) ->
      new_active = @active
      for i in Object.keys(new_active)
        if i != item
          new_active[i] = false

      new_active[item] = !new_active[item]
      @active = Object.assign({}, new_active)

    slicePictureBuble: (item) ->
      len= null 
      if @dados[@selected][item].Carousel != undefined && @dados[@selected][item].Carousel != null
        if @dados[@selected][item].Carousel.carousel_users != undefined && @dados[@selected][item].Carousel.carousel_usesr != null
          aux = @dados[@selected][item].Carousel.carousel_users
          len = Object.keys(aux).length
          resultado= Object.fromEntries(Object.entries(aux).slice(3,len))
        return resultado
         
    slicePicture: (item) ->
      if @dados[@selected][item].Carousel
          aux = @dados[@selected][item].Carousel.carousel_users
          resultado= Object.fromEntries(Object.entries(aux).slice(0,3))
        return resultado
    successId: (response)->
      for i in response.custom_fields
        if i.kind == 'dropdown' && i.field == @selected
         @id = i.id
    successCallback: (response)->
      len = response.custom_fields.length
      @dados = {}
      for x in [0..len-1]
        if response.custom_fields[x]['kind'] == 'dropdown'
          @dados[response.custom_fields[x]['field']]={}
          @selected_copy[response.custom_fields[x]['field']]={}
          @property_id_group[response.custom_fields[x]['field']]
          if response.custom_fields[x]['field'] == @selected
            @id=response.custom_fields[x]['id']
          objeto=response.custom_fields[x]["options"]
          saizeOption=response.custom_fields[x]["options"].length
          for j in [0..saizeOption-1]
            @dados[response.custom_fields[x]['field']][objeto[j]['name']]={"Carousel":undefined}
            @selected_copy[response.custom_fields[x]['field']][(objeto[j]['name'])] = {"custom_field_value":(objeto[j]['name']),"selected": false }

          @selected_copy[response.custom_fields[x]['field']]["Outros"]={"custom_field_value":"Outros","selected": false }
          @dados[response.custom_fields[x]['field']]["Outros"]={"Carousel":undefined}
      @$emit 'property_id', @id

    modalTitle: ->
      if @config == true
        return this.$t('integrations.actions.update.carousel')
      else
        return this.$t('integrations.label.setCarousel')
    fillRdCopy: (response)->
      for i in response
        @dados[@selected][i.custom_field_value].Carousel = i
    
    copyConfig: (mensagem)->
      @dados_modal = @dados[@selected]
      @custom_select = { 'id': 0, 'value': '' }
      @custom_select['value'] = mensagem

      @custom_select['id'] = @id
      @datacopy=true
      @show_modal = true  

    selectedCarousel: (mensagem) ->
      @loading_carousel = true 
      @custom_select = { 'id': 0, 'value': '' }
      @dados_modal = {}
      if mensagem != this.$t('general.label.others')
        if @dados[@selected][mensagem].Carousel
            @dados_modal = @dados[@selected][mensagem].Carousel

        if @dados[@selected][mensagem].Carousel == null || @dados[@selected][mensagem].Carousel == undefined
          @custom_select['value'] = mensagem
          @custom_select['id'] = @id
      else if mensagem == this.$t('general.label.others')
        for i in Object.keys(@dados[@selected])
          if @dados[@selected][i].Carousel
            if @dados[@selected][i].Carousel.custom_field_value == null
              @dados_modal = @dados[@selected][i].Carousel
          @custom_select['value'] = null
          @custom_select['id'] = @id
      @datacopy=false
      @loading_carousel = false 
      @show_modal = true

    fillRdCarousel: (carousel) ->

      @custom_select['value'] = this.$t('general.label.others') if @custom_select['value'] == null
      @dados[@selected][@custom_select['value']].Carousel = carousel
      @dados_modal = {}
      @show_modal = false

    copy_config: (item)->
      if @dados[@selected][item] && @dados[@selected][item].Carousel
        return false
      else
        return true

    text_config: (item)->
      if @dados[@selected] && @dados[@selected][item] && @dados[@selected][item].Carousel
        return this.$t('integrations.actions.update.carousel')
      else
        return this.$t('integrations.label.setCarousel')

    loadUsersSuccess: (data) ->
      @users = data.users.filter (user) -> !user.isAdmin()
      @users = data.users
      @loading_users = false

    loadUsers: ->
      @loading_users = true
      params = {q: {accepted: true, s: 'name asc'}}
      params['company_id'] = @company_id if @current_user.isAdmin()
      new UsersResource().index(@loadUsersSuccess, @unknownError, {params})
  
    loadCarousel: (data) ->
      if data
        @carousel = data.carousel_by_property
        @selected_users = data.carousel_by_property.carousel_users
        @loading_table= true
      else
        @loading_carousel = true
        new CarouselPropertyResource().show(@loadCarouselSuccess, @loadCarouselFailure, params: { q:{kind_eq:2,type_eq:'CarouselByProperty'} })

    loadCarouselSuccess: (data) ->
      len = null
      if data != undefined && Object.keys(data).length > 0 && @dados != undefined
        for x in data
          if x.custom_field_value == null
            @dados[@selected][this.$t('general.label.others')].Carousel=x
          else if x.custom_field_value != null && x.custom_field_value != undefined && @dados[@selected][x.custom_field_value] != undefined 
            @dados[@selected][x.custom_field_value].Carousel=x
      config = true
      @loading_table = true
      @loading_carousel = false

    loadCarouselFailure: (data) ->
      if data.status == 404
        @carousel = new Carousel
      else
        @unknownError

  created: ->
    params = {
      q: {
        kind_eq: 'dropdown'
      }
    }
    new CustomFieldsResource().index(@successCallback, null, params)
    
    @loadUsers()
    @loadCarousel()
    @loading_table = false

  mounted: ->
    @text_config()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/properties_table.vue